import { connect } from 'dva';

import { Bubble, Button, Modal, notification } from 'tea-component';
import { LoadingOutlined } from '@ant-design/icons';
import React from 'react';

// import {useSelector} from 'umi';
import { namespace } from '../model';
import { SaveModel } from './SaveModel';
import { useDblIntl } from "@/pages/datalab/utils/utils";

export default connect((state: any) => {
  const { saveObj, task_id, analysisRunning, columnMetrics = [] } = state[namespace];
  return {
    saveObj,
    task_id,
    analysisRunning,
    columnMetrics,
  };
})(AnalysisCalculate);

function AnalysisCalculate(props: any) {
  const { dblFormatMessage: explorationFormatMessage, commonFormatMessage, isEn } = useDblIntl("exploration");
  const { saveObj, task_id, analysisRunning, columnMetrics, showSaveModel, setShowSaveModel } = props;
  // const { gameCode } = useSelector((state) => ({gameCode: state.datalab.gameCode}));

  const disableButton = !columnMetrics || columnMetrics.length === 0;

  const dispatchFun = (path: string, payload: {}, callback?: Function) => {
    props.dispatch({
      type: `${namespace}/${path}`,
      payload,
      callback,
    });
  };

  const calculate = () => {
    props.dispatch({
      type: `${namespace}/getDataAnlysis`,
      payload: {},
      callback: (payload: {errorMsg: string;}) => {
        if (payload?.errorMsg) {
          notification.error({
            className: 'dbl-analysis-msg',
            description: payload.errorMsg,
            duration: 3000
          });
        }
        dispatchFun('save', {
          ...(payload || {}),
          analysisRunning: false,
          analysisReqId: '',
        });
      },
    });
  };

  const cancelAnalysis = () => {
    dispatchFun('cancelAnalysis', {
      cancelTip(status: "success" | "error") {
        const tips = {
          "success": ["Cancel calculation successful", "终止计算成功"],
          "error": ["Cancel calculation failed", "终止计算失败"]
        };
        notification[status]({
          className: `downDataBox downData${  status}`,
          description: tips[status][isEn ? 0 : 1],
          duration: 3000
        });
      }
    });
  };

  // const save = () => {
  //   setShowSaveModel(true);
  // };

  const clearAll = () => {
    Promise.resolve(
      Modal.confirm({
        className: 'model-delect',
        message: <div className="model-delect-title">{explorationFormatMessage("clear_message")}</div>,
        description: (
          <div className="model-delect-text">
            {explorationFormatMessage("clear_des")}
          </div>
        ),
        okText: commonFormatMessage("confirm"),
        cancelText: commonFormatMessage("cancel"),
      }),
    ).then((result) => {
      if (result) {
        dispatchFun('clearQuery', {});
      }
    });
  };

  return (
    <div className="footer-flex">
      <SaveModel
        showSaveModel={showSaveModel}
        setShowSaveModel={setShowSaveModel}
        namespace={namespace}
        dispatch={props.dispatch}
        data={{ ...{ taskId: task_id }, ...saveObj }}
      />
      {analysisRunning ? (
        <Button type="primary" className="item-btn" onClick={cancelAnalysis}>
          {explorationFormatMessage("finish_calculate")}
          <LoadingOutlined style={{ color: 'white', marginLeft: '5px' }} />
        </Button>
      ) : (
        <Bubble
          dark={true}
          style={{ display: disableButton ? '' : 'none' }}
          arrowPointAtCenter
          placement="top"
          content={
            <div>
              <p>{explorationFormatMessage("not_empty_metric")}</p>
            </div>
          }
        >
          <Button type="primary" className="item-btn" disabled={disableButton} onClick={calculate}>
            {explorationFormatMessage("calculate")}
          </Button>
        </Bubble>
      )}
      {/* <Button htmlType="button" className="item-btn" disabled={disableButton} onClick={save}>
        {commonFormatMessage("save")}
      </Button> */}

      <Button htmlType="button" className="item-btn" disabled={disableButton} onClick={clearAll}>
        {commonFormatMessage("clear")}
      </Button>
    </div>
  );
}
